import { wrapRequest, meWrapRequest } from "./nav";
import { wrapGqlRequest } from "@/services/graphqlEndPointCommonSetting/wrapGqlRequest";
import {
  doSetPaymentMethodOnCart,
  doPlaceOrderMutation,
  setGuestEmailOnCart,
  isEmailAvailable,
} from "./graphQl/guest_graphql.service";
import { formatPlaceOrderResponse } from "@/services/util.service";
import {
  placeOrderWithRetry,
  setPaymentMethodWithRetry,
} from "@/services/placeOrderWithRetry";

const vueAppMagenotApiUrl = import.meta.env.VITE_MAGENTO_API_URL;
const retailorId = import.meta.env.VITE_RETAILOR_ID;
const vueAppNodeslsApiUrl = import.meta.env.VITE_NODESLS_API_URL;
const vueAppAccsBaseUrl = import.meta.env.VITE_ACCS_BASE_URL;
export const doFetchBasicInfo = async () => {
  let address = {
    id: "",
    group_id: "",
    default_billing: "",
    default_shipping: "",
    created_at: "",
    updated_at: "",
    created_in: "",
    email: "",
    firstname: "",
    lastname: "",
    store_id: "",
    website_id: "",
    addresses: [
      {
        id: "",
        customer_id: "",
        region: {
          region_code: "",
          region: "",
          region_id: "",
        },
        region_id: "",
        country_id: "",
        street: [""],
        telephone: "",
        postcode: "",
        city: "",
        firstname: "",
        lastname: "",
      },
    ],
  };

  return address;
};

export const doValidateAddress = wrapRequest((address) => {
  const requestOptions = {
    method: "GET",
  };
  return fetch(
    "https://maps.googleapis.com/maps/api/geocode/json?address=" +
      address +
      "&key=AIzaSyDmHp0PPuKHD1KGHCDmLq1qQKr_03XKEHo",
    requestOptions,
  );
});
export const doFetchCheckEmailAvailable = async (email) => {
  // const requestOptions = {
  //   method: "POST",
  //   headers: {
  //     "Content-type": "application/json",
  //     "Access-Control-Allow-Origin": "*",
  //   },
  //   body: JSON.stringify({
  //     customerEmail: email,
  //     websiteId: 1,
  //   }),
  // };

  // return fetch(
  //   `${vueAppMagenotApiUrl}/rest/V1/customers/isEmailAvailable`,
  //   requestOptions
  // );
  const response = await isEmailAvailable(email);
  return response?.isEmailAvailable?.is_email_available;
};
// export const doFetchEstimatedShippingMethods = wrapRequest((address, email, guestQuoteId) => {
//     let streetAddress = [];
//     let streetArray = [];
//     if (address.streetNoTwo == " " || address.streetNoTwo == undefined) {
//         streetAddress[0] = address.streetNoOne;
//         streetArray = streetAddress.filter(v => v != '');
//     } else {
//         streetAddress[0] = address.streetNoOne
//         streetAddress[1] = address.streetNoTwo;
//         streetArray = streetAddress.filter(v => v != '');
//     }
//     const requestOptions = {
//         method: 'POST',
//         headers: {
//             'Content-type': 'application/json',
//         },
//         body: JSON.stringify({
//             "address": {
//                 "region_id": address.regionId,
//                 "country_id": address.countryId,
//                 "street": streetArray,
//                 "postcode": address.postcode,
//                 "city": address.city,
//                 "firstname": address.firstname,
//                 "lastname": address.lastname,
//                 "email": email,
//                 "same_as_billing": 1
//             }
//         }),
//     };
//     return fetch(`${vueAppMagenotApiUrl}/rest/V1/guest-carts/${guestQuoteId}/estimate-shipping-methods`, requestOptions)
// });
export const doFetchEstimatedShippingMethods = async (
  address,
  guestQuoteId,
) => {
  let streetAddress = [];
  if (!address.streetNoTwo || address.streetNoTwo.trim() === "") {
    streetAddress = [address.streetNoOne];
  } else {
    streetAddress = [address.streetNoOne, address.streetNoTwo];
  }
  const query = `
   mutation {
     estimateShippingMethods(
       input: {
         cart_id: "${guestQuoteId}"
         address: {
           country_code: ${address.countryId}
           region: {
             region_id: ${address.regionId}
           }
           postcode: "${address.postcode}"
         }
       }
     ) {
       carrier_code
       carrier_title
       method_code
       method_title
       error_message
       amount {
         currency
         value
       }
       price_excl_tax {
         currency
         value
       }
       price_incl_tax {
         currency
         value
       }
     }
   }
 `;
  const response = await wrapGqlRequest(query, {}, "estimateShippingMethods");
  return response.map((method) => ({
    carrier_code: method.carrier_code,
    carrier_title: method.carrier_title,
    method_code: method.method_code,
    method_title: method.method_title,
    error_message: method.error_message,
    amount: method.amount?.value ?? 0,
    base_amount: method.amount?.value ?? 0,
    available: true,
    price_excl_tax: method.price_excl_tax?.value ?? 0,
    price_incl_tax: method.price_incl_tax?.value ?? 0,
  }));
};
// export const doShippingInformation = wrapRequest((address, estimated, email, guestQuoteId, suggestedAddress) => {
//     let streetAddress = [];
//     let streetArray = [];
//     if (address.streetNoTwo == " " || address.streetNoTwo == undefined) {
//         streetAddress[0] = suggestedAddress.streetNoOne ? suggestedAddress.streetNoOne : address.streetNoOne;
//         streetArray = streetAddress.filter(v => v != '');
//     } else {
//         streetAddress[0] = suggestedAddress.streetNoOne ? suggestedAddress.streetNoOne : address.streetNoOne
//         streetAddress[1] = suggestedAddress.streetNoTwo ? suggestedAddress.streetNoTwo : address.streetNoTwo;
//         streetArray = streetAddress.filter(v => v != '');
//     }
//     const requestOptions = {
//         method: 'POST',
//         headers: {
//             'Content-type': 'application/json',
//         },
//         body: JSON.stringify({
//             "addressInformation": {
//                 "shipping_address": {
//                     "region_id": suggestedAddress.region_id ? suggestedAddress.region_id : address.regionId,
//                     "country_id": suggestedAddress.country_id ? suggestedAddress.country_id : address.countryId,
//                     "street": streetArray,
//                     "postcode": suggestedAddress.postcode ? suggestedAddress.postcode : address.postcode,
//                     "city": suggestedAddress.city ? suggestedAddress.city : address.city,
//                     "firstname": address.firstname,
//                     "lastname": address.lastname,
//                     "email": email ?email.trim():null,
//                     "telephone": address.telephone
//                 },
//                 "shipping_carrier_code": estimated.carrierCode,
//                 "shipping_method_code": estimated.methodCode
//             }
//         })
//     };
//     return fetch(`${vueAppMagenotApiUrl}/rest/V1/guest-carts/${guestQuoteId}/shipping-information`, requestOptions)
// });
export const doShippingInformation = async (
  address,
  estimated,
  email,
  guestQuoteId,
  suggestedAddress,
) => {
  let streetArray = [];
  if (!address.streetNoTwo || address.streetNoTwo.trim() === "") {
    streetArray = [suggestedAddress.streetNoOne || address.streetNoOne].filter(
      (v) => v !== "",
    );
  } else {
    streetArray = [
      suggestedAddress.streetNoOne || address.streetNoOne,
      suggestedAddress.streetNoTwo || address.streetNoTwo,
    ].filter((v) => v !== "");
  }

  // Prepare the address
  const addressData = {
    firstname: address.firstname,
    lastname: address.lastname,
    street: streetArray,
    city: suggestedAddress.city || address.city,
    postcode: suggestedAddress.postcode || address.postcode,
    telephone: address.telephone,
    country_code: suggestedAddress.country_id || address.countryId,
    region: address.regionCode || address.regionId,
    save_in_address_book: false,
  };

  // Set Shipping Addresses On Cart
  await wrapGqlRequest(
    `
     mutation ($input: SetShippingAddressesOnCartInput!) {
       setShippingAddressesOnCart(input: $input) {
         cart { id }
       }
     }
     `,
    {
      input: {
        cart_id: guestQuoteId,
        shipping_addresses: [{ address: addressData }],
      },
    },
    "setShippingAddressesOnCart",
  );
  // Set Shipping Methods On Cart
  await wrapGqlRequest(
    `
     mutation ($input: SetShippingMethodsOnCartInput!) {
       setShippingMethodsOnCart(input: $input) {
         cart { id }
       }
     }
     `,
    {
      input: {
        cart_id: guestQuoteId,
        shipping_methods: [
          {
            carrier_code: estimated.carrierCode,
            method_code: estimated.methodCode,
          },
        ],
      },
    },
    "setShippingMethodsOnCart",
  );
  // change if needed data also
  return null;
  const cart = await wrapGqlRequest(
    `
     query ($cartId: String!) {
     cart(cart_id: $cartId) {
       itemsV2 {
         items {
           uid
           quantity
           prices {
             price { value currency }
             row_total { value currency }
             row_total_including_tax { value currency }
             total_item_discount { value currency }
             discounts { amount { value currency } }
           }
           product {
             name
             sku
           }
         }
       }
       prices {
         grand_total { value currency }
         subtotal_excluding_tax { value currency }
         subtotal_including_tax { value currency }
         discounts { label amount { value currency } }
         applied_taxes { amount { value currency } }
       }
       shipping_addresses {
         firstname
         lastname
         street
         city
         postcode
         telephone
         selected_shipping_method {
           carrier_code
           carrier_title
           method_code
           method_title
           amount { value currency }
         }
       }
       available_payment_methods {
         code
         title
       }
     }
   }
     `,
    { cartId: guestQuoteId },
    "cart",
  );
  const items = cart.itemsV2.items.map((item) => ({
    item_id: item.uid,
    qty: item.quantity,
    price: item.prices.price.value,
    base_price: item.prices.price.value,
    row_total: item.prices.row_total.value,
    base_row_total: item.prices.row_total.value,
    row_total_with_discount:
      item.prices.row_total.value -
      (item.prices.total_item_discount?.value || 0),
    base_row_total_with_discount:
      item.prices.row_total.value -
      (item.prices.total_item_discount?.value || 0),
    tax_amount: item.prices.total_item_discount?.value || 0,
    base_tax_amount: item.prices.total_item_discount?.value || 0,
    price_incl_tax: item.prices.row_total_including_tax.value,
    base_price_incl_tax: item.prices.row_total_including_tax.value,
    row_total_incl_tax: item.prices.row_total_including_tax.value,
    base_row_total_incl_tax: item.prices.row_total_including_tax.value,
    discount_amount: item.prices.total_item_discount?.value || 0,
    base_discount_amount: item.prices.total_item_discount?.value || 0,
    name: item.product.name,
  }));
  const totals = {
    grand_total: cart.prices.grand_total.value,
    base_grand_total: cart.prices.grand_total.value,
    subtotal: cart.prices.subtotal_excluding_tax.value,
    base_subtotal: cart.prices.subtotal_excluding_tax.value,
    discount_amount: cart.prices.discounts?.[0]?.amount.value || 0,
    base_discount_amount: `-${(cart?.prices?.discounts || []).reduce(
      (sum, tax) => {
        return sum + parseFloat(tax.amount.value);
      },
      0,
    )}`,
    subtotal_with_discount:
      cart.prices.subtotal_excluding_tax.value -
      (cart.prices.discounts?.[0]?.amount.value || 0),
    base_subtotal_with_discount:
      cart.prices.subtotal_excluding_tax.value -
      (cart.prices.discounts?.[0]?.amount.value || 0),
    shipping_amount:
      cart.shipping_addresses?.[0]?.selected_shipping_method?.amount?.value ||
      0,
    base_shipping_amount:
      cart.shipping_addresses?.[0]?.selected_shipping_method?.amount?.value ||
      0,
    items_qty: items.reduce((sum, i) => sum + i.qty, 0),
    items,
    total_segments: [
      {
        code: "subtotal",
        title: "Subtotal",
        value: cart.prices.subtotal_excluding_tax.value,
      },
      {
        code: "shipping",
        title: `Shipping & Handling (${cart.shipping_addresses?.[0]?.selected_shipping_method?.carrier_title} - ${cart.shipping_addresses?.[0]?.selected_shipping_method?.method_title})`,
        value:
          cart.shipping_addresses?.[0]?.selected_shipping_method?.amount
            ?.value || 0,
      },
      {
        code: "grand_total",
        title: "Order Total",
        value: cart.prices.grand_total.value,
        area: "footer",
      },
      {
        code: "tax",
        value: (cart?.prices?.applied_taxes || []).reduce((sum, tax) => {
          return sum + parseFloat(tax.amount.value);
        }, 0),
      },
    ],
    tax_amount: (cart?.prices?.applied_taxes || []).reduce((sum, tax) => {
      return sum + parseFloat(tax.amount.value);
    }, 0),
  };
  const totalDiscAmount =
    (cart?.prices?.discounts || []).reduce((sum, disc) => {
      return sum + parseFloat(disc.amount.value);
    }, 0) ?? 0.0;
  if (totalDiscAmount > 0) {
    totals?.total_segments?.push({
      code: "discount",
      title: cart?.prices?.discounts[0]?.label,
    });
  }
  const payment_methods = (cart.available_payment_methods || []).filter(
    (method) => method.code && method.title,
  );
  const shipping_address = cart.shipping_addresses?.[0] ?? null;

  return { payment_methods, shipping_address, totals };
};
export const doSetBillingInformation = async (guestQuoteId, address, email) => {
  // Prepare the address

  const addressData = {
    firstname: address.firstname,
    lastname: address.lastname,
    street: address.street,
    city: address.city,
    postcode: address.postcode,
    telephone: address.telephone,
    country_code: address.countryId,
    region: address.regionId,
    save_in_address_book: false,
  };
  // Set Guest Email On Cart
  await wrapGqlRequest(
    `
     mutation ($input: SetGuestEmailOnCartInput!) {
       setGuestEmailOnCart(input: $input) {
         cart { email }
       }
     }
     `,
    { input: { cart_id: guestQuoteId, email: email?.trim() || "" } },
    "setGuestEmailOnCart",
  );

  // Set Billing Address On Cart
  return await wrapGqlRequest(
    `
     mutation ($input: SetBillingAddressOnCartInput!) {
       setBillingAddressOnCart(input: $input) {
         cart { id }
       }
     }
     `,
    {
      input: {
        cart_id: guestQuoteId,
        billing_address: { address: addressData },
      },
    },
    "setBillingAddressOnCart",
  );
};
export const doProductsOrder = async ({ guestQuoteId, paymentMethod }) => {
  // console.log("guestQuoteId", guestQuoteId);
  // console.log("paymentMethod", paymentMethod);
  // Await the setting of the payment method before placing the order
  // Retried too: the card is already charged, and until this succeeds placeOrder
  // is never attempted at all.
  const setPayment = await setPaymentMethodWithRetry({
    setPaymentMethod: () =>
      doSetPaymentMethodOnCart(guestQuoteId, paymentMethod),
    isSuccess: (response) => Boolean(response),
    cartId: guestQuoteId,
  });

  if (setPayment?.alreadyPlaced) {
    return { alreadyPlaced: true, code: setPayment.code };
  }

  const setPaymentResult = setPayment?.response;
  // After setting the payment method, call the placeOrder mutation
  // and return the result.
  // Check if the payment method was set successfully
  if (setPaymentResult) {
    // Payment is already captured by this point, so placement is retried rather
    // than failed outright. setPaymentMethodOnCart is not re-sent per attempt:
    // it persists on the quote once applied.
    const result = await placeOrderWithRetry({
      placeOrder: () => doPlaceOrderMutation(guestQuoteId),
      cartId: guestQuoteId,
    });

    if (result?.orderV2) {
      return formatPlaceOrderResponse(result.orderV2);
    }
    if (result?.alreadyPlaced) {
      return { alreadyPlaced: true, code: result.code };
    }
    return { message: result?.message || "Unknown error occurred" };
  } else {
    // Card is already charged at this point, so this must throw rather than
    // return — checkout_page.vue's catch reports to Datadog, and a plain
    // return here would silently land the customer on the pending page with
    // no signal that the payment method never actually attached to the cart.
    throw new Error("Failed to set payment method on cart");
  }

  // return fetch(
  //   `${vueAppMagenotApiUrl}/rest/V1/guest-carts/${guestQuoteId}/payment-information`,
  //   requestOptions
  // );
};
export const doProductsOrderOnCC = meWrapRequest(
  (orderNumber, shippingAddress, webOrderNumber) => {
    let address2 = shippingAddress.street[1]
      ? shippingAddress.street[1]
      : undefined;
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        retailorId: retailorId,
        orderNumber: orderNumber,
        shipToFirstName: shippingAddress.firstname,
        shipToLastName: shippingAddress.firstname,
        shipToAddress1: shippingAddress.street[0],
        shipToAddress2: address2,
        shipToCity: shippingAddress.city,
        shipToState: shippingAddress.regionCode,
        shipToZip: shippingAddress.postcode,
        shipToCountry: shippingAddress.countryId,
        shipToPhone: shippingAddress.telephone,
        shipToEmail: shippingAddress.email,
        shippingMethod: "usp",
        webOrderNumber: webOrderNumber,
      }),
    };
    return fetch(`${vueAppNodeslsApiUrl}/cc-submit-order`, requestOptions);
  },
);

export const setPaymentMethodIntant = wrapRequest(
  (guestQuoteId, cartFullName) => {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        cartId: guestQuoteId,
        cartFullName: cartFullName,
      }),
    };
    return fetch(`${vueAppAccsBaseUrl}`, requestOptions);
  },
);
export const doSetPaymentInformation = meWrapRequest(
  (email, guestQuoteId, paymentMethod, address) => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        billingAddress: address,
        paymentMethod: paymentMethod,
        comments: "",
      }),
    };
    return fetch(
      `${vueAppMagenotApiUrl}/rest/V1/guest-carts/${guestQuoteId}/set-payment-information`,
      requestOptions,
    );
  },
);
export const doPlaceOrder = meWrapRequest((guestQuoteId) => {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify({}),
  };
  return fetch(
    `${vueAppMagenotApiUrl}/rest/V1/guest-carts/${guestQuoteId}/order`,
    requestOptions,
  );
});
